import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-slate-200 last:border-0" data-id="element-55">
      <button className="flex w-full items-center justify-between py-4 text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-56">
        <span className="font-medium text-slate-900 pr-8" data-id="element-57">{question}</span>
        {isOpen ? <ChevronUp className="h-5 w-5 text-slate-500 flex-shrink-0" data-id="element-58" /> : <ChevronDown className="h-5 w-5 text-slate-500 flex-shrink-0" data-id="element-59" />}
      </button>
      {isOpen && <div className="pb-4 text-slate-600 leading-relaxed animate-in fade-in slide-in-from-top-2 duration-200" data-id="element-60">
          {answer}
        </div>}
    </div>;
}
export function FAQ() {
  const faqs = [{
    question: 'Do you guarantee credit score increases?',
    answer: 'No. DanyCredit provides educational consulting and strategy. We cannot and do not guarantee specific score increases, as credit scoring models are complex and depend on many factors unique to your history.'
  }, {
    question: 'Is this a credit repair service?',
    answer: 'No. We are not a credit repair organization. We do not dispute accurate negative items on your behalf. Our focus is on education, analysis of your report for errors you can address, and strategic planning for future financial health.'
  }, {
    question: 'How does the consultation work?',
    answer: "You'll meet with a specialist who will review your financial goals and current situation. We'll provide a neutral, third-party perspective on your credit profile and suggest actionable steps you can take to improve your standing over time."
  }, {
    question: 'Can you help with business credit?',
    answer: 'Yes. We offer consulting on business credit readiness, helping you understand how to separate personal and business finances and build a strong foundation for your company.'
  }];
  return <div className="max-w-3xl mx-auto" data-id="element-61">
      {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-62" />)}
    </div>;
}